import { ConfigProvider, Input } from "antd";
import React from "react";
import "./InputField.scss";

const InputField = ({
  label,
  placeholder,
  onlyNumbers = false,
  addonBefore,
  type = "text",
  value,
  onChange,
  disabled,
}) => {
  const handleKeyPress = (e) => {
    if (onlyNumbers && !/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <div className="inputFieldMain" style={{ borderRadius: "6px" }}>
      {label && <label className="inputLabel">{label}</label>}
      <ConfigProvider theme={{ components: { Input: {} } }}>
        <Input
          addonBefore={addonBefore}
          type={type}
          placeholder={placeholder}
          onKeyPress={handleKeyPress}
          onChange={onChange}
          value={value}
          disabled={disabled ? disabled : false}
        />
      </ConfigProvider>
    </div>
  );
};

export default InputField;
